<section class="responsible-company-section scroll-parallax" data-aos="fade-up" data-aos-delay="0"
    data-aos-duration="600">

    <div class="header">

        <app-badge [text]="header.badge" ></app-badge>
         <h2 class="title-section">
            Somos una Empresa comprometida con el<br>
            <span class="highlight-text">Desarrollo Sostenible</span>
        </h2>
        <p class="header-description">{{ header.description }}</p>
    </div>

    <div class="additional-content">
        <div class="decorative-image">
            <img [src]="decorativeImage.src" [alt]="decorativeImage.alt" loading="lazy">
        </div>  
        <div class="principles-grid">
            <div class="principle-item" *ngFor="let principle of principles">
                <div class="principle-header">
                    <div class="principle-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">

                            <path *ngIf="principle.iconPath" [attr.d]="principle.iconPath"></path>
                            <path *ngFor="let path of principle.iconPaths" [attr.d]="path"></path>
                            <circle *ngIf="principle.iconCircle" [attr.cx]="principle.iconCircle.cx"
                                [attr.cy]="principle.iconCircle.cy" [attr.r]="principle.iconCircle.r">
                            </circle>
                            <polyline *ngIf="principle.iconPolyline" [attr.points]="principle.iconPolyline"></polyline>
                        </svg>
                    </div>
                    <h3 class="principle-title">{{ principle.title }}</h3>
                </div>
                <p class="principle-description">{{ principle.description }}</p>
            </div>
        </div>
    </div>

</section>
